import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const CompanyInfoPage = Loadable(
  lazy(() =>
    import("./pages/CompanyInfoPage").then(({ CompanyInfoPage }) => ({
      default: CompanyInfoPage,
    }))
  )
);

const SubscriptionPlanPage = Loadable(
  lazy(() =>
    import("./pages/SubscriptionPlanPage").then(({ SubscriptionPlanPage }) => ({
      default: SubscriptionPlanPage,
    }))
  )
);

const OrgSettingsPage = Loadable(
  lazy(() =>
    import("./pages/OrgSettingsPage").then(({ OrgSettingsPage }) => ({
      default: OrgSettingsPage,
    }))
  )
);

const CompanyOutletRedirect = Loadable(
  lazy(() =>
    import("./CompanyOutletRedirect").then(({ CompanyOutletRedirect }) => ({
      default: CompanyOutletRedirect,
    }))
  )
);

export const CompanyOutletRoutes = [
  {
    path: "/company-outlet",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.COMPANY_OUTLET]}>
        <CompanyOutletRedirect />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/company-outlet/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.COMPANY_OUTLET]}>
        <CompanyInfoPage />
      </AuthorizedRoute>
    ),
  },

  // Separate pages for each step
  {
    path: "/company-outlet/company-info/:uuid",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.COMPANY_OUTLET]}>
        <CompanyInfoPage />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/company-outlet/subscription/:uuid",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.COMPANY_OUTLET]}>
        <SubscriptionPlanPage />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/company-outlet/org-settings/:uuid",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.COMPANY_OUTLET]}>
        <OrgSettingsPage />
      </AuthorizedRoute>
    ),
  },


  
];
